
export type FormattingOptionItem = 'bold' | 'italic' | 'header' | 'list' | 'mention' | 'link';

export const FormattingOptionItem = {
    all: ['bold', 'italic', 'header', 'list', 'mention', 'link'] as FormattingOptionItem[],
    defaults: ['bold', 'italic', 'header', 'list', 'mention'] as FormattingOptionItem[],
};
